import { DeviceStatus } from '../types/device-status';
import { ProviderMessage } from '../types/provider-message';

/* eslint-disable @typescript-eslint/no-explicit-any */
export const APP_INIT_SAGA = 'app/APP_INIT_SAGA';
export const APP_INIT_COMPLETE = 'app/APP_INIT_COMPLETE';
export const APP_AUTH_ERROR_SAGA = 'app/APP_AUTH_ERROR_SAGA';
const APP_INITIAL_STATUS_REQUESTED = 'app/APP_INITIAL_STATUS_REQUESTED';
const APP_INITIAL_STATUS_COMPLETED = 'app/APP_INITIAL_STATUS_COMPLETED';
export const QSRV_ID_SET = 'app/QSRV_ID_SET';

export const WS_RESPONSE_ERROR = 'web-socket/response-error';

export const PROVIDER_MESSAGE_SAGA = 'app/PROVIDER_MESSAGE_SAGA';

export const DEVICE_STATUSES_UPDATED = 'app/DEVICE_STATUSES_UPDATED';
export const PROVIDER_MESSAGE_UPDATED = 'app/PROVIDER_MESSAGE_UPDATED';

export const SHOW_APP_ERROR = 'app/SHOW_APP_ERROR';
export const CLEAR_APP_ERROR = 'app/CLEAR_APP_ERROR';

export function showAppError(message: string, hideAfter = 4) {
  return { type: SHOW_APP_ERROR, hideAfter, message };
}

export function appInitSaga(payload: any) {
  return { type: APP_INIT_SAGA, payload };
}

export function providerMessageSaga(message: ProviderMessage) {
  return { type: PROVIDER_MESSAGE_SAGA, message };
}

export function appInitialStatusRequested() {
  return { type: APP_INITIAL_STATUS_REQUESTED };
}

export function appInitialStatusCompleted() {
  return { type: APP_INITIAL_STATUS_COMPLETED };
}

export function clearAppError() {
  return { type: CLEAR_APP_ERROR };
}

export interface AppState {
  initialized: boolean;
  authError: boolean;
  showAppError: boolean;
  lastErrorMessage: string | null;
  initialStatusRequestInProgress: boolean;
  providerMessage: ProviderMessage | null;
  deviceStatuses: Array<DeviceStatus>;
}

const initialState: AppState = {
  initialized: false,
  authError: false,
  showAppError: false,
  lastErrorMessage: null,
  initialStatusRequestInProgress: false,
  providerMessage: null,
  deviceStatuses: []
};

// Reducer
export function appReducer(state: AppState = initialState, action: any = {}): AppState {
  switch (action.type) {
    case APP_INIT_COMPLETE: {
      return { ...state, initialized: true };
    }
    case PROVIDER_MESSAGE_UPDATED: {
      return { ...state, providerMessage: action.providerMessage };
    }
    case DEVICE_STATUSES_UPDATED: {
      return { ...state, deviceStatuses: action.deviceStatuses };
    }
    case APP_INITIAL_STATUS_REQUESTED: {
      return { ...state, initialStatusRequestInProgress: true };
    }
    case APP_INITIAL_STATUS_COMPLETED: {
      return { ...state, initialStatusRequestInProgress: false };
    }
    case 'web-socket/auth-error/cbx': {
      return { ...state, authError: true };
    }
    case SHOW_APP_ERROR: {
      const lastErrorMessage = action.message;
      return { ...state, showAppError: true, lastErrorMessage };
    }
    case CLEAR_APP_ERROR: {
      return { ...state, showAppError: false, lastErrorMessage: null };
    }
    case 'web-socket/booth-authenticate/cbx': {
      return { ...state, authError: false };
    }
    default: {
      return state;
    }
  }
}
